<template>
  <div class="content md flex-box vertical meeting-room">
    <div class="content-title">
      <div class="content-title-btn title-btn-left" v-if="showBack">
        <a-button shape="circle" icon="left" @click="$router.go(-1)"/>
      </div>
      <div class="content-title-text">会议室列表</div>
      <div class="content-title-btn title-btn-right">
        <a-button type="primary" @click="showAddMeeting"><a-icon type="plus-circle" />创建会议室</a-button>
      </div>
    </div>
    <div class="gap"></div>
    <div class="flex-grow scroll-area">
      <div class="meeting-room-list" v-if="list && list.length > 0">
        <a-card :title="m.room_name" class="meeting-room-item" v-for="(m, i) in list" :key="m.id">
          <a-space slot="extra" class="meeting-room-operate">
            <a-tooltip>
              <template slot="title">编辑会议室</template>
              <a-button size="small" shape="circle" icon="edit" @click="editMeetingRoom(i)" />
            </a-tooltip>
            <a-tooltip>
              <template slot="title">删除会议室</template>
              <a-button type="danger" size="small" shape="circle" icon="delete" @click="deleteMeetingRoom(i)" />
            </a-tooltip>
          </a-space>
          <detail-view :list="m.detailList" full class="group-info">
            <li class="detail-item">
              <div class="detail-label">参会人员</div>
              <div class="detail-value">
                <div class="add-person-list" v-if="m.person && m.person.length > 0">
                  <div class="add-person-item" v-for="(item, i) in m.person" :key="i">
                    <a-icon class="add-person-icon" type="user" />
                    <div class="add-person-name">{{item.name}}<span class="add-person-mobile">{{item.mobile}}</span></div>
                  </div>
                </div>
                <span v-else>无</span>
              </div>
            </li>
          </detail-view>
        </a-card>
      </div>
      <a-empty :image="simpleImage" description="暂无会议室" v-else-if="list"/>
    </div>
    <div class="flex-box vertical meeting-room-form" :class="{'meeting-form-visible': show}">
      <div class="content-title">
        <div class="content-title-btn title-btn-left" @click="hideMeetingForm">
          <a-button shape="circle" icon="left" />
        </div>
        <div class="content-title-text">{{index === null ? '创建会议室' : '编辑会议室'}}</div>
      </div>
      <div class="gap"></div>
      <form-area
        ref="modalForm"
        class="flex-grow scroll-area flex-box vertical"
        layout="horizontal"
        :label-col="{span: 3}"
        :wrapper-col="{span: 9}"
        :items="items"
        :entity="form"
        :loading="loading"
        @cancel="cancelEdit"
        @confirm="confirmMeeting"
        confirm-text="确定">
      </form-area>
    </div>
  </div>
</template>

<script>
    import {Empty} from "ant-design-vue";
    import DetailView from "../../components/detail-view";
    import {getDate, omit} from "../../common/js/tool";
    import {getShowFileList} from "../../common/js/file";

    export default {
        name: "ActivityMeetingRoom",
        components: {
            DetailView,
        },
        data() {
            return {
                list: null,
                show: false,
                items: [
                    {
                        key: 'room_name',
                        label: '会议室名称',
                        component: 'a-input',
                        props: {
                            placeholder: '请输入会议室名称',
                        },
                        rules: [{ required: true, message: '请输入会议室名称', trigger: 'blur' }]
                    },
                    {
                        key: 'address',
                        label: '会议室地址',
                        component: 'a-input',
                        props: {
                            placeholder: '请输入会议室地址',
                        },
                        rules: [{ required: true, message: '请输入会议室地址', trigger: 'blur' }]
                    },
                    {
                        key: 'count',
                        label: '容纳人数',
                        component: 'a-input-number',
                        props: {
                            placeholder: '请输入容纳人数',
                        },
                        style: {
                            width: '100%'
                        },
                        rules: [{ required: true, message: '请输入容纳人数', trigger: 'blur' }]
                    },
                    {
                        key: 'time',
                        label: '会议时间',
                        component: 'a-range-picker',
                        props: {
                            showTime: {format: 'HH:mm'},
                            format: 'YYYY-MM-DD HH:mm',
                            valueFormat: 'YYYY-MM-DD HH:mm',
                            placeholder: ['开始时间', '截止时间']
                        },
                        rules: [{ required: true, message: '请设置会议时间', trigger: 'change' }]
                    },
                    {
                        key: 'topic',
                        label: '会议主题',
                        component: 'a-input',
                        props: {
                            placeholder: '请输入会议主题',
                        },
                        rules: [{ required: true, message: '请输入会议主题', trigger: 'blur' }]
                    },
                    {
                        key: 'desc',
                        label: '会议说明',
                        component: 'a-input',
                        props: {
                            placeholder: '请输入会议说明',
                        },
                        rules: [{ required: true, message: '请输入会议说明', trigger: 'blur' }]
                    },
                    {
                        key: 'files',
                        label: '会议文件',
                        component: 'file-upload',
                        props: {
                            limit: -1
                        },
                    },
                    {
                        key: 'person',
                        label: '参会成员',
                        component: 'add-person',
                    },
                ],
                form: {},
                index: null,
                loading: false,
                simpleImage: Empty.PRESENTED_IMAGE_SIMPLE
            }
        },
        computed: {
            activity() {
                return this.$store.getters.activity;
            },
            showBack() {
                // const include = this.$store.getters.include;
                // return include.length > 1 && include[include.length - 2] === "ActivityGroup";
                return false;
            }
        },
        watch: {
            activity() {
                this.getMeetingRoomList();
            }
        },
        created() {
            this.getMeetingRoomList();
        },
        methods: {
            confirmMeeting(form) {
                this.loading = true;
                const data = omit(form, ['id', 'time', 'files', 'person']);
                data.start_time = form.time[0];
                data.end_time = form.time[1];
                data.file = form.files ? JSON.stringify(form.files) : null;
                data.attend_list = form.person ? JSON.stringify(form.person) : null;
                let url = "/activity/activity-meeting", method = "POST";
                if(form.id) {
                    url += `/${form.id}`;
                    method = 'PATCH';
                } else {
                    data.activity_id = this.activity.id;
                }
                this.$axios({
                    url,
                    method,
                    data
                }).then(res => {
                    this.dealMeetingRoom(res);
                    if(this.index === null) {
                        this.list.unshift(res);
                    } else {
                        this.list.splice(this.index , 1, res);
                    }
                    this.cancelEdit();
                }).finally(() => this.loading = false);
            },
            cancelEdit() {
                this.show = false;
            },
            showAddMeeting() {
                this.index = null;
                this.form = {};
                this.show = true;
            },
            deleteMeetingRoom(i) {
                this.$confirm({
                    title: '提示',
                    content: '确定删除此会议室吗？',
                    onOk: () => {
                        const m = this.list[i];
                        const url = `/activity/activity-meeting/${m.id}`;
                        this.$axios({
                            url,
                            method: 'DELETE'
                        }).then(() => {
                            this.$message.success('已删除');
                            this.list.splice(i, 1);
                        });
                    }
                })
            },
            editMeetingRoom(i) {
                const m = this.list[i];
                this.index = i;
                const form = {
                    id: m.id,
                    room_name: m.room_name,
                    address: m.address,
                    count: m.count,
                    time: [m.start_time, m.end_time],
                    topic: m.topic,
                    desc: m.desc,
                };
                if(m.file) {
                    try {
                        form.files = JSON.parse(m.file);
                    } catch (e) {
                        console.error(e);
                    }
                }
                if(m.person) {
                    form.person = m.person;
                }
                this.form = form;
                this.show = true;
            },
            hideMeetingForm() {
                this.show = false;
            },
            getMeetingRoomList() {
                const activity = this.activity;
                if(activity) {
                    const url = `/activity/activity-meeting?pageSize=1000&sort=start_time&filter[activity_id]=${activity.id}`;
                    this.$axios(url).then(res => {
                        const list = res.data;
                        list.forEach(this.dealMeetingRoom);
                        this.list = list;
                    });
                }
            },
            dealMeetingRoom(meeting) {
                if(meeting.attend_list) {
                    try {
                        meeting.person = JSON.parse(meeting.attend_list);
                    } catch (e) {
                        console.error(e);
                    }
                }
                meeting.detailList = [
                    {label: '会议室名称', value: meeting.room_name},
                    {label: '会议室地址', value: meeting.address},
                    {label: '容纳人数', value: meeting.count + '人'},
                    {label: '开始时间', value: getDate(meeting.start_time).pattern("yyyy-MM-dd HH:mm"), gap: true},
                    {label: '结束时间', value: getDate(meeting.end_time).pattern("yyyy-MM-dd HH:mm")},
                    {label: '会议主题', value: meeting.topic, gap: true},
                    {label: '会议说明', value: meeting.desc},
                    {label: '会议文件', value: getShowFileList(meeting.file), vertical: true, gap: true, file: true},
                ]
            }
        }
    }
</script>

<style lang="less">
.meeting-room {
  position: relative;
  overflow: hidden;
}
.meeting-room-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: -1%;
}
.meeting-room-item {
  margin-top: 2%;
  width: 49%;
  &.full-width  {
    width: 100%;
    .detail-label {
      line-height: 24px;
    }
  }
}
.meeting-room-form {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: @padding-md @padding-md 0;
  background-color: @body-background;
  transition: transform .3s;
  transform: translateX(100%);
  &.meeting-form-visible {
    transform: translateX(0);
  }
}
</style>
